// SPDX-License-Identifier: AGPL-3.0-or-later
import * as ChannelCommands from '@app/features/channel/commands/ChannelCommands';
import {selectChannel} from '@app/features/navigation/commands/NavigationCommands';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {ChannelTypes} from '@app/vendor/constants/ChannelConstants';
export interface FormInputs {
	name: string;
	url: string | null;
	type: string;
}
export interface ChannelTypeOption {
	value: number;
	name: string;
	desc: string;
}
export const channelTypeOptions: Array<ChannelTypeOption> = [
	{
		value: ChannelTypes.GUILD_TEXT,
		name: 'Text Channel',
		desc: 'Send messages, images, GIFs, and emoji',
	},
	{
		value: ChannelTypes.GUILD_VOICE,
		name: 'Voice Channel',
		desc: 'Hang out together with voice, video, and screen share',
	},
	{
		value: ChannelTypes.GUILD_LINK,
		name: 'Link Channel',
		desc: 'Quick access to an external website or resource',
	},
];
export async function createChannel(guildId: string, data: FormInputs, parentId?: string): Promise<void> {
	const channelType = Number(data.type);
	const channel = await ChannelCommands.create(guildId, {
		name: data.name,
		url: data.url,
		type: channelType,
		parent_id: parentId || null,
		bitrate: channelType === ChannelTypes.GUILD_VOICE ? 64000 : null,
		user_limit: channelType === ChannelTypes.GUILD_VOICE ? 0 : null,
	});
	if (channel.type === ChannelTypes.GUILD_TEXT || channel.type === ChannelTypes.GUILD_VOICE) {
		setTimeout(() => {
			selectChannel(guildId, channel.id);
		}, 50);
	}
	ModalCommands.pop();
}
export function getDefaultValues(): Partial<FormInputs> {
	return {
		type: ChannelTypes.GUILD_TEXT.toString(),
	};
}
